<template>
  <section>
    <PageName title="Причины обмена/возврата" :buttons="this.buttons" />

    <Preloader v-if="returnReasonsLoading" />

    <VTable
      v-show="!returnReasonsLoading"
      itemsType="array"
      :columns="reasonsColumns"
      :items="mapedReasons"
      :sortApi="sortReasons"
      :selectedIndices="selectedIndices"
      @select="select"
      @row-click="openReason"
      selectable
      ref="table"
    />
  </section>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import { deleteReturnReasons } from "@/api/returnReasons";
import PageName from "@/components/PageName";
import Preloader from "@/components/Preloader";
import VTable from "@/components/Table/VTable";

export default {
  name: "ReturnReasons",
  components: {
    PageName,
    Preloader,
    VTable,
  },

  data() {
    return {
      selectedReasonsIds: [],
      reasonsColumns: [
        { title: "№", sort: false, value: "id" },
        { title: "Причина", sort: false, value: "name" },
      ],
      paramsWidthSort: {
        page: 1,
        sort: "id",
        search: "",
      },
      search: "",
      buttons: [
        {
          text: "Создать",
          icon: "addFile",
          event: this.create || {},
        },
        {
          text: "Удалить",
          icon: "delete",
          event: this.delete || {},
          iconWidth: "12px",
        },
      ],
    };
  },

  computed: {
    ...mapState("returnReasons", ["returnReasons", "returnReasonsLoading"]),
    ...mapGetters("returnReasons", ["getReturnReasonsListPagination"]),

    mapedReasons() {
      return this.returnReasons?.map((reason) => {
        return [reason.id, reason.name];
      });
    },
    selectedIndices: {
      get() {
        const indeces = [];

        this.returnReasons.forEach((reason, i) => {
          if (this.selectedReasonsIds[reason.id] !== undefined) {
            indeces.push(i);
          }
        });

        return indeces;
      },
      set(val) {
        const ids = [];
        for (let index = 0; index < val.length; index++) {
          const reason = this.returnReasons[val[index]];
          if (reason?.id) ids[reason.id] = reason;
        }
        this.selectedReasonsIds = ids;
      },
    },
  },

  methods: {
    ...mapActions("returnReasons", ["getReturnReasons"]),

    openReason(num) {
      const node = this.returnReasons[num - 1];
      this.$router.push({
        name: "ReturnReasonUpdate",
        params: { node, id_reason: node.id },
      });
    },

    getPage(pageNum) {
      const params = {
        page: pageNum,
        sort: this.paramsWidthSort.sort,
        search: this.paramsWidthSort.search,
      };
      this.$store.dispatch("returnReasons/getReturnReasonsListPage", params);
    },

    sortReasons(col, sort) {
      this.paramsWidthSort = {
        page: 1,
        sort: (sort ? "" : "-") + col?.value,
        search: this.paramsWidthSort.search,
      };
      this.$store.dispatch(
        "returnReasons/getReturnReasonsListPage",
        this.paramsWidthSort
      );
    },

    select(value, index, all = null) {
      if (all !== null) {
        this.selectedIndices = all ? this.returnReasons.map((el, i) => i) : [];
      } else if (value) {
        this.selectedIndices = [...this.selectedIndices, index];
      } else {
        this.selectedIndices = this.selectedIndices.filter((i) => i === index);
      }
    },

    delete() {
      if (this.selectedReasonsIds.length) {
        const deleteCallback = async () => {
          this.selectedReasonsIds.map(({ id }) => {
            deleteReturnReasons(id).finally(() => this.getReturnReasons());
          });
          this.selectedReasonsIds = [];
          this.$root.alert("Удаление прошло успешно");
        };
        this.$root.confrim(
          "Вы уверены, что хотите удалить выбранные причины?",
          deleteCallback,
          "Да"
        );
      }
    },

    create() {
      this.$router.push({ name: 'ReturnReasonCreate' })
    },
  },

  destroyed() {
    this.$store.commit('returnReasons/RESET_REASONS_LIST_CURRENT_PAGE')
  },

  watch: {
    search(val) {
      this.paramsWidthSort = {
        page: 1,
        sort: this.paramsWidthSort.sort,
        search: val,
      };
      this.$store.dispatch(
        "returnReasons/getReturnReasonsListPage",
        this.paramsWidthSort
      );
    },
  },
};
</script>
